import React from 'react';

export default function BexcodeLogo({ size = 28, showText = true, textColor }) {
  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 10, flexShrink: 0, verticalAlign: 'middle' }}>
      <svg 
        width={size} 
        height={size} 
        viewBox="0 0 100 100" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg" 
        style={{ flexShrink: 0 }}
      >
        {/* Main stylized 'b' outer body in Bexcode Red */}
        <path 
          d="M42 12C63 12 85 28 85 54C85 76 68 90 48 90C25 90 15 70 15 50C15 26 23 12 42 12Z" 
          fill="#ff3b20" 
        />
        {/* Inner white cutout swirl */}
        <path 
          d="M48 42C54 42 60 48 60 55C60 62 52 68 44 68C36 68 33 60 36 53C39 46 42 42 48 42Z" 
          fill="#ffffff" 
        />
      </svg>
      {showText && (
        <span 
          style={{ 
            fontSize: size * 0.72, 
            fontWeight: 800, 
            fontFamily: "'Outfit', 'Inter', sans-serif", 
            letterSpacing: '-0.5px', 
            display: 'flex', 
            alignItems: 'center',
            lineHeight: 1
          }}
        >
          <span style={{ color: '#ff3b20' }}>bex</span>
          <span style={{ color: textColor || 'var(--trello-text)', display: 'inline-flex', alignItems: 'center' }}>
            <span style={{ color: '#ff3b20', fontWeight: 600 }}>&lt;</span>
            <span>code</span>
            <span style={{ color: '#ff3b20', fontWeight: 600 }}>&gt;</span>
          </span>
        </span>
      )}
    </div>
  );
}
